import { Spacer } from '@zillow/constellation';

import { ParagraphStyledComponent } from '../ParagraphStyledComponent';
import { TextStyledComponent } from '../TextStyledComponent';

import type { TextStyledComponentProps } from '../../model/TextStyledComponent';
import type { ParagraphStyledComponentProps } from '../../model/ParagraphStyledComponent';

type ContentStyledComponent = {
  title: TextStyledComponentProps;
  content: Array<ParagraphStyledComponentProps>;
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
};

export const ContentStyledComponent = ({ title, content, csEventsHandler, csEventsIdMap }: ContentStyledComponent) => {
  return (
    <>
      {title.text && (
        <Spacer marginBottom="sm">
          <TextStyledComponent styledComponentContent={title} />
        </Spacer>
      )}
      {content.map((paragraph, i) => {
        return (
          <Spacer key={i} marginY="xs" data-testid="ParagraphStyledComponentSpacer">
            <ParagraphStyledComponent
              heading={paragraph.heading}
              body={paragraph.body}
              type={paragraph.type}
              csEventsHandler={csEventsHandler}
              csEventsIdMap={csEventsIdMap}
            />
          </Spacer>
        );
      })}
    </>
  );
};
